export enum CtlComEnum {
  USER_DEF_VAL='自定义',
  COMMON_DEF_VAL='快捷配置',
  DEFAULT_SET='defaultSet',
  DEFAULT_DIS='disabled',
  RECORD_KEY='id',
  GONG_SI_EDITOR='公式编辑',
  NUMBER_2='number2',
  NUMBER_3='number3',
  NUMBER_4='number4',
  NUMBER_5='number5',
  NUMBER='number',
  PRICE_2='price2',
  PRICE_3='price3',
  PRICE='price',
}
